module.exports = {
    'IsMobile': require('./isMobile'),
    'IsTablet': require('./isTablet'),
    'IsAtLeastTablet': require('./isAtLeastTablet'),
    'IsDesktopSm': require('./isDesktopSm'),
    'IsAtLeastDesktopSm': require('./isAtLeastDesktopSm'),
    'IsDesktop': require('./isDesktop')
};